module.exports = __webpack_public_path__ + "img/matplotlib.37bce99c.png";